{
  "name": "bignerve-app-vite",
  "version": "3.260.0",
  "description": "BigNerve App v3",
  "private": true,
  "scripts": {
    "dev": "NODE_NO_WARNINGS=1 vite --host bignerve.local --port 4001 --profile",
    "build": "npm run netlify:routes && vite build",
    "preview": "vite preview",
    "release": "release-it",
    "server": "npx json-server dist/db.json",
    "netlify:routes": "node netlify/scripts/extract-routes.mjs"
  },
  "release-it": {
    "git": {
      "commitMessage": "chore(release): v${version}",
      "push": true,
      "commit": true,
      "tag": true,
      "requireCommits": false,
      "requireCleanWorkingDir": false
    },
    "github": {
      "release": false,
      "draft": true
    },
    "npm": {
      "publish": false,
      "ignoreVersion": false
    },
    "plugins": {
      "@release-it/conventional-changelog": {
        "preset": "angular",
        "infile": "CHANGELOG.md",
        "header": "# Changelog"
      }
    },
    "hooks": {
      "after:release": "echo Successfully released ${name} v${version} to ${repo.repository}."
    }
  },
  "dependencies": {
    "@bignerve/meme-generator": "^0.0.19",
    "@bignerve/ui-charts": "1.1.3",
    "@bignerve/ui-core": "2.0.0-beta.84",
    "@bignerve/ui-icons": "1.23.0",
    "@bignerve/ui-shared": "^0.0.1-beta.36",
    "@bignerve/ui-utils": "1.2.4",
    "@casl/ability": "^6.7.3",
    "@number-flow/vue": "^0.3.0",
    "@popperjs/core": "^2.11.6",
    "@sentry/vue": "^10.4.0",
    "@stripe/stripe-js": "^3.0.7",
    "@tanstack/query-persist-client-core": "^5.60.6",
    "@tanstack/vue-query": "^5.60.6",
    "@unhead/vue": "^1.11.20",
    "@vueup/vue-quill": "^1.2.0",
    "@vueuse/components": "^14.2.1",
    "@vueuse/core": "^14.2.1",
    "@vueuse/integrations": "^14.2.1",
    "@vueuse/router": "^14.2.1",
    "axios": "1.14.0",
    "canvas-confetti": "^1.9.3",
    "class-variance-authority": "^0.7.0",
    "clsx": "^2.1.1",
    "comlink": "^4.4.1",
    "cropperjs": "^1.5.12",
    "d3": "^7.6.1",
    "defu": "^6.1.0",
    "dompurify": "^3.4.13",
    "embla-carousel-vue": "^8.6.0",
    "flatpickr": "^4.6.13",
    "floating-vue": "^2.0.0-beta.24",
    "fuse.js": "^6.6.2",
    "handlebars": "^4.7.9",
    "idb-keyval": "^6.2.1",
    "lodash": "^4.17.23",
    "markdown-it-anchor": "^8.6.6",
    "markdown-it-emoji": "^2.0.2",
    "markdown-it-link-attributes": "^4.0.1",
    "marked": "^16.1.2",
    "maska": "^1.5.0",
    "mitt": "^3.0.0",
    "moment": "^2.29.4",
    "moment-timezone": "^0.6.0",
    "nanoid": "^5.1.16",
    "normalize-url": "^8.0.1",
    "nprogress": "^0.2.0",
    "papaparse": "^5.5.2",
    "pusher-js": "^7.4.0",
    "quill": "^1.3.7",
    "quill-magic-url": "^4.2.0",
    "quill-markdown-shortcuts": "^0.0.10",
    "quill-mention": "^4.1.0",
    "quill-paste-smart": "^1.4.12",
    "radix-vue": "^1.9.2",
    "sortablejs": "^1.15.6",
    "string-similarity-js": "^2.1.4",
    "tailwind-merge": "^2.4.0",
    "turndown": "^7.2.0",
    "turndown-plugin-gfm": "^1.0.2",
    "tus-js-client": "^4.3.1",
    "twitter-text": "^3.1.0",
    "universal-cookie": "^4.0.4",
    "uuid": "^9.0.0",
    "v-plausible": "^1.2.0",
    "vue": "^3.5.40",
    "vue-i18n": "^9.14.3",
    "vue-router": "^5.2.0",
    "vue-sonner": "^1.1.4",
    "vue3-smooth-dnd": "^0.0.6"
  },
  "devDependencies": {
    "@bignerve/ui-preset": "1.2.4",
    "@intlify/vite-plugin-vue-i18n": "^6.0.3",
    "@release-it/conventional-changelog": "^8.0.1",
    "@sentry/vite-plugin": "^4.1.0",
    "@tailwindcss/aspect-ratio": "^0.4.2",
    "@tailwindcss/typography": "^0.5.10",
    "@vitejs/plugin-vue": "^6.0.8",
    "autoprefixer": "^10.4.14",
    "postcss": "^8.4.27",
    "release-it": "^21.0.1",
    "sass": "^1.55.0",
    "tailwindcss": "^3.3.3",
    "vite": "^8.2.0",
    "vite-plugin-comlink": "^3.0.5",
    "vite-plugin-pwa": "^1.0.2",
    "vite-plugin-vue-devtools": "^7.6.8",
    "vite-plugin-vue-markdown": "^0.22.1"
  }
}
